module.exports = __webpack_public_path__ + "img/facebook.e179476f.svg";